import {
  isArray,
  isNumber,
  isFunction,
  indexOf
} from 'lodash';
import axios from "axios";
// import qs from "qs";

// axios 配置
export const http = axios.create({
  // timeout: 50000,
  withCredentials: true,
  headers: {
    common: {
      'X-Requested-With': 'XMLHttpRequest',
    },
    post: {
      "Content-Type": "application/json; charset=utf-8"
    }
  }
});

http.interceptors.request.use(
  config => {
    if (localStorage.getItem('accessToken')) {
      let token = localStorage.getItem('accessToken');
      config.headers.common['accessToken'] = token;
    }
    return config;
  },

  err => {
    return Promise.reject(err);
  },
);


export function injectLoginRequired(cb) {

  function getRes(obj) {
    let res = obj.response;
    if (res) {
      return res;
    } else {
      return obj;
    }
  }

  http.interceptors.response.use(resp => {
    const {
      status,
      data
    } = getRes(resp);
    if (status === 403 || (data && data.errno === 403) || (data &&
        data.status === 'failed' &&
        data.message === '用户登陆失效')) {

      http.post('/api/oa/get-login-url').then(res => {
        if (res.status === 'success') {
          // this.$cookies.remove('certificate_key', '/', '.linkdoc.com');
          location.href = res.data[0];
        }
      })

      return Promise.reject(resp);
    }
    return resp.data || resp;
  }, error => {
    const {
      status,
      data
    } = getRes(error) || {};
    if (status === 403 || (data && data.status === 403) || status === 500) {
      cb(error);
    }

    return Promise.reject(error);
  });
}

injectLoginRequired();


export function delayIt(fn, {
  delay = 100
} = {}) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(fn());
      } catch (ex) {
        reject(ex);
      }
    }, delay);
  });
}

function makeRejectReason({
  type,
  resp,
  http,
  msg
}) {
  return {
    type,

    ...(resp ? {
      msg: (resp.message || resp.msg || '') + (resp.err ? `; err: ${resp.err}` : ''),
      status: resp.status,
      code: resp.code,
      httpStatus: http.status,
      http,
    } : {}),

    ...(msg ? {
      msg,
    } : {}),
  };
}


/**
 * wrapAjax - 处理 Ajax 响应
 * 会处理 resp.status, 和 resp.msg, 自动 reject.
 *
 * wrapAjax(ajax, {
 *   okStatus: [200, 201],
 *   fixData: data => data.items.map(item => convertToObject(item)),
 * });
 */
export function wrapAjax(ajaxPromise, {
  fixData,
  okStatus = [200, 'success']
} = {}) {
  let p = ajaxPromise;

  let okStatusFn = null;
  if (isArray(okStatus)) {
    okStatusFn = (s) => (indexOf(okStatus, s) !== -1);
  } else if (isNumber(okStatus)) {
    okStatusFn = (s) => (okStatus == s);
  } else if (isFunction(okStatus) || okStatus === null) {
    okStatusFn = okStatus;
  } else {
    throw new Error('wrapAjax: invalid okStatus');
  }

  p = p.then((httpResp) => {
    let resp = httpResp;
    if (okStatusFn && !okStatusFn(httpResp.status)) {
      return Promise.reject(makeRejectReason({
        type: 'reqFail',
        resp,
        http: httpResp
      }));
    }
    if (resp.status !== 0 && resp.status !== 'success') {
      return Promise.reject(makeRejectReason({
        type: 'reqFail',
        resp,
        http: httpResp
      }));
    }

    let retData = fixData ? fixData(resp.data, resp, httpResp) : resp.data;

    return retData;
  }, (httpResp) => {
    let resp = httpResp.data;

    return Promise.reject(makeRejectReason({
      type: 'ajaxFail',
      resp,
      http: httpResp
    }));
  });

  return p;
}